<template>
  <div class="bg-sub-search">
    <div class="container header-page">
      <div class=""  v-if="Searchvideo.length">
        <h4 class="header-search"><i class="fa fa-fighter-jet"></i> ค้นหา</h4>
        <div class="box-search" v-for="video in Searchvideo" @click="PlaySearchContent(video)">
          <div class="video-search">
            <figure class="sixteen-nine-img float-left thumb-search">
              <p class="duration">{{video.duration}}</p>
              <img :src="video.thumb" >
              <div class="btn-overlay-cate">
                <fa icon="play" class="icon-play"/>
              </div>
            </figure>
          </div>
          <div class="detail-search">
            <h5 class="title-search">{{video.name}}</h5>
            <p class="channal-search">{{video.desc}}</p>
          </div>
        </div>
      </div>

      <div class="container notfound" v-if="!Searchvideo.length">
        <p class="text-search">ข้อความที่ค้นหาคือ - <span class="input-search">{{SearchKeyword}}</span> - ไม่มีข้อมูลในระบบ</p>
        <h5 class="header-search mb-3 mt-3">ข้อเสนอแนะ :</h5>
        <p class="text-search"> • กรอกข้อมูลที่ต้องการค้นหาให้ถูกต้อง</p>
        <p class="text-search"> • ลองเปลี่ยนคีย์เวิร์ดในการค้นหา</p>
        <p class="text-search"> • ลองเพิ่มคีย์เวิร์ดให้มากขึ้น</p>
      </div>
    </div>
  </div>

</template>

<script>
import config from '../config';
import axios from 'axios';
const Host = config.app.Host;
import {
  mdbRow,
  mdbCol,
  Btn,
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  Fa,
  Modal,
  ModalHeader,
  ModalTitle,
  ModalBody,
  ModalFooter
} from 'mdbvue';
export default {
  name: 'SearchingPage',
  components: {
    mdbRow,
    mdbCol,
    Btn,
    mdbCard,
    mdbCardBody,
    mdbCardHeader,
    Fa,
    Modal,
    ModalHeader,
    ModalTitle,
    ModalBody,
    ModalFooter
  },
  data() {
    return {
      SearchKeyword: '',
      Searchvideo: []
    };
  },
  mounted() {
    this.SearchContent();
    this.ToggleLogin();
    localStorage.pincode = '';
    this.Session();
  },
  methods: {
    Session() {
      let APIgetSession = Host + '/api/v1/member/session';
      axios.post(APIgetSession , {
        token: localStorage.token
      }).then(response => {
        if (response.data.code !== '200') {
          localStorage.emailfront = '';
          localStorage.token = '';
          localStorage.auth = 'false';
        }
      });
    },
    ToggleLogin() {
      if (localStorage.auth == 'false' || !localStorage.auth) {
        this.$router.push('/');
      }
      this.modalLogin = true;
    },
    PlaySearchContent(data) {
      document.location.assign('/#/vod/' + data.id);
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    SearchContent() {
      let keywords = this.$route.params.keywords;
      let APIgetSearchContent = Host + '/api/v1/search/video';
      axios.post(APIgetSearchContent , {
        keyword: keywords
      }).then(response => {
        if (keywords === 'undefined' || keywords === null) {
          this.SearchKeyword = ' ';
        } else {
          this.SearchKeyword = keywords;
        }
        this.Searchvideo = response.data.result;
      });
    }
  },
  watch: {
    '$route'(to, from) {
      this.SearchContent();
    }
  }
};
</script>

<style>

</style>
